<template>
    <div class="move-opportunity-flow-content">
        <div class="move-opportunity-flow-content-box">
            <form ref="moveOpportunityFlowForm">
                <span class="summary-label">{{ MESSAGE_CONSTANTS.info_summary }}</span>
                <p class="summary-text">
                    {{ MESSAGE_CONSTANTS.info_message }}
                </p>
                <ds-multiselect
                    v-model="stageValue"
                    :placeholder="MESSAGE_CONSTANTS.stage_placeholder"
                    :options="stageOptions"
                    help-text
                    pin-bottom
                    bind-value-only
                    searchable
                />
                <ds-multiselect
                    v-model="opportunityCriteriaValue"
                    :placeholder="MESSAGE_CONSTANTS.criteria_placeholder"
                    :options="MESSAGE_CONSTANTS.opportunityCriteriaOptions"
                    help-text
                    pin-bottom
                    bind-value-only
                    searchable
                />
                <ds-checkbox
                    v-model="ignoreWonLost"
                    :label="MESSAGE_CONSTANTS.ignore_won_lost_label"
                />
                <p class="summary-text">
                    {{ MESSAGE_CONSTANTS.note_message }}
                </p>

                <ds-icon-button
                    :aria-label="MESSAGE_CONSTANTS.close"
                    class="closemodal"
                    @click="closeModal"
                >
                    <ds-icon name="x" />
                </ds-icon-button>

                <ds-filled-button
                    class="savebutton"
                    :disabled="saveDisabled"
                    @click="saveCell"
                >
                    {{ MESSAGE_CONSTANTS.save }}
                </ds-filled-button>
            </form>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        vueComponentId: String,
        stageOptionsString: String,
    },
    data () {
        return {
            jgraph: {},
            cellInfo: {},
            cellValue: {},
            saveCellOptions: {},
            ignoreWonLost: true,
            stageValue: 0,
            opportunityCriteriaValue: 'recentlyCreated',
            stageOptions: JSON.parse(this.stageOptionsString),
            MESSAGE_CONSTANTS: {
                save: '',
                info_summary: '',
                note_message: '',
                info_message: '',
                stage_placeholder: '',
                criteria_placeholder: '',
                checkbox_label: '',
                ignore_won_lost_label: '',
                opportunityCriteriaOptions: [
                    {
                        label: '',
                        value: 'recentlyCreated',
                    },
                    {
                        label: '',
                        value: 'recentlyUpdated',
                    },
                    {
                        label: '',
                        value: 'all',
                    },
                ],
            },
        };
    },
    created () {
        this.MESSAGE_CONSTANTS.info_message = window.keapI18nMap['campaign.move.oppurtunity.info.message'];
        this.MESSAGE_CONSTANTS.note_message = window.keapI18nMap['campaign.move.oppurtunity.note.message'];
        this.MESSAGE_CONSTANTS.criteria_placeholder = window.keapI18nMap['campaign.move.oppurtunity.criteria.placeholder'];
        this.MESSAGE_CONSTANTS.stage_placeholder = window.keapI18nMap['campaign.move.oppurtunity.stage.placeholder'];
        this.MESSAGE_CONSTANTS.info_summary = window.keapI18nMap['campaign.move.oppurtunity.info.summary'];
        this.MESSAGE_CONSTANTS.save = window.keapI18nMap['campaign.move.oppurtunity.save'];
        this.MESSAGE_CONSTANTS.checkbox_label = window.keapI18nMap['campaign.move.oppurtunity.checkbox.label'];
        this.MESSAGE_CONSTANTS.ignore_won_lost_label = window.keapI18nMap['campaign.move.oppurtunity.move.ignore.won.lost.label'];
        this.MESSAGE_CONSTANTS.opportunityCriteriaOptions[0].label = window.keapI18nMap['campaign.move.oppurtunity.recently.created'];
        this.MESSAGE_CONSTANTS.opportunityCriteriaOptions[1].label = window.keapI18nMap['campaign.move.oppurtunity.recently.updated'];
        this.MESSAGE_CONSTANTS.opportunityCriteriaOptions[2].label = window.keapI18nMap['campaign.move.oppurtunity.move.all'];
    },
    mounted () {
        document.getElementById(this.vueComponentId).addEventListener('loadCellValueObject', this.loadCellValueObject);
        document.querySelector('span.container-close').className += ' hide-element';
    },
    beforeDestroy () {
        document.getElementById(this.vueComponentId).removeEventListener('loadCellValueObject');
    },
    computed: {
        saveDisabled () {
            return !(this.stageValue !== 0 && this.opportunityCriteriaValue !== undefined);
        },
    },
    methods: {
        loadCellValueObject (event) {
            this.$nextTick(() => {
                this.jgraph = event.detail.jgraph;
                this.cellInfo = event.detail.cellInfo;
                this.cellValue = event.detail.cellValue;
                this.saveCellOptions = event.detail.options;
                this.saveCellOptions.saver = undefined;

                if (this.cellValue.stageToMove) {
                    if (this.cellValue) {
                        this.stageValue = parseInt(this.cellValue.stageToMove, 10);
                    }

                    if (this.cellValue.configOption) {
                        this.opportunityCriteriaValue = this.cellValue.configOption;
                    }

                    if (this.cellValue.ignoreWonLost !== undefined) {
                        this.ignoreWonLost = !!this.cellValue.ignoreWonLost;
                    }
                }
            });
        },
        saveCell () {
            this.cellValue.stageToMove = `${this.stageValue.toString()}L`;
            this.cellValue.configOption = this.opportunityCriteriaValue;
            this.cellValue.ignoreWonLost = this.ignoreWonLost ? 1 : 0;
            const eventData = {
                detail: {
                    cellValue: this.cellValue,
                    cellInfo: this.cellInfo,
                    jgraph: this.jgraph,
                    options: this.saveCellOptions,
                },
            };

            this.$emit('save-cell', eventData);
            this.closeModal();
        },
        closeModal () {
            document.querySelector('span.container-close').click();
        },
    },
};
</script>
<style lang="scss">
    .move-opportunity-flow-content {
        .multiselect {
            label {
                margin-top: -6px;
                &.static-label {
                    margin-top: 0px;
                }
            }
            &.active {
                .input-container {
                    label {
                        margin-top: 0px;
                        top: -1;
                        &.static-label {
                            top: -1;
                        }
                    }
                }
            }
        }
        svg.icon {
            width: 48px;
            padding-left: 0px;
        }
        div.dropdown-menu.open > div.menu {
            height: min-content;
        }
        label.pill-label{
            display: none !important;
        }
        .modal-footer {
            visibility: hidden;
            display: none;
        }
        form {
            padding: 15px;
        }
        span.summary-label {
            color: rgba(0, 0, 0, 0.4);
        }
        p.summary-text {
            margin-top: 4px;
            margin-bottom: 24px;
        }
        div#lightbox {
            display: grid;
            grid-template-areas: 'containerclose headertext savebutton' 'lightboxcontent lightboxcontent lightboxcontent';
            grid-template-columns: 6% 80% 14%;
            background-color: #fff;
            width: 640px !important;
            border-radius:12px;
        }
        div#lightbox > span.container-close {
            grid-area: containerclose;
            background-color: #fff;
            padding: 0;
            margin: 0;
            left: 20px;
            width: 10px;
            height: 10px;
            border-bottom: 1px solid #DDDDDD;
        }
        div#lightbox > div#lightbox-content {
            grid-area: lightboxcontent;
            border-top: 1px solid #DDDDDD;
        }
        div#lightbox > div.hd {
            grid-area: headertext;
            background-color: #fff;
            border-bottom: none;
            height: 56px;
            padding-top: 11px;
        }
        form > .closemodal {
            grid-area: containerclose;
            position: absolute;
            top: 10px;
            left: 8px;
        }
        form > .savebutton {
            grid-area: savebutton;
            position: absolute;
            top: 12px;
            right: 16px;
            height: 32px;
            width: 55px;
            padding: 0;
        }
        .content {
            padding-top: 0px;
        }
        .hide-element {
            visibility: hidden;
        }
    }
</style>
